<template>
  <div class="form-row form-material p-4">
    <select-input :fieldOptions="customers" :currentValue.sync="customer" class="col-4"/>
    <!--select-input :fieldOptions="containers" :currentValue.sync="container" class="col-4"/-->
    <div class="form-group form-default col-4">
      <input type="text" v-model="branch" class="form-control" :placeholder="tr('Branch')"/>
    </div>

    <button type="button" class="btn btn-primary mb-2 mx-1" @click="restartContainer" :disabled="updating || importing">
      {{ tr('Restart') }}
    </button>
    <span v-if="updating">{{ tr('Restarting...') }}</span>

    <button type="button" class="btn btn-primary mb-2 mx-1" @click="importBackup" :disabled="updating || importing">
      {{ tr('Import Backup') }}
    </button>

    <button type="button" class="btn btn-primary mb-2 mx-1" @click="setBranch" :disabled="updating || importing || !branch || !container">
      {{ tr('Set Branch') }}
    </button>

    <span v-if="importing">{{ tr('Importing...') }}</span>
  </div>
</template>

<script>
export default {
  name: 'servers-maintenance',
  props: {
    customers: {
      type: Array,
      default: () => [
        { label: 'Raja Tours Indonesia', value: 'raja' },
        { label: 'Argentina On The Go', value: 'aotg' },
        { label: 'Designer Trips', value: 'dstrip' },
        { label: 'Innovart Tours', value: 'innova' },
        { label: 'New World Travel Designers', value: 'nwtd' },
        { label: 'Mater Sustentable', value: 'mater' },
        { label: 'Quarum Travel', value: 'quarum' },
        { label: 'Signagures DMC', value: 'signa' },
        { label: 'Demo', value: 'demo' },
        { label: 'Test', value: 'test' }
      ]
    }
  },
  data () {
    return {
      devTestEndpoint: 'https://api-test.nubbo.io',
      branch: null,
      customer: null,
      updating: false,
      importing: false,
      container: 'devtest',
      containers: [
        { label: 'devtest', value: 'devtest' },
        { label: 'nubbo', value: 'nubbo' }
      ]
    }
  },
  methods: {
    async restartContainer () {
      this.updating = true;
      try {
        await api.get('/api/clear_cache_all/');
      } catch (e) { /* noop */ }
      fetch(`${this.devTestEndpoint}/services/restart?profile=${this.customer}&container=devtest`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-type': 'application/json'
        }
      })
      .then(() => {
        alert(this.tr('Finished'));
        this.updating = false;
      })
      .catch((error) => {
        alert(error);
        this.updating = false;
      });
    },
    async setBranch () {
      this.updating = true;
      try {
        await api.get('/api/clear_cache_all/');
      } catch (e) { /* noop */ }
      fetch(`${this.devTestEndpoint}/services/set_branch?profile=${this.customer}&branch=${this.branch}&container=${this.container}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-type': 'application/json'
        }
      })
      .then(() => {
        alert(this.tr('Finished'));
        this.updating = false;
      })
      .catch((error) => {
        alert(error);
        this.updating = false;
      });
    },
    async importBackup () {
      this.importing = true;
      try {
        await api.get('/api/clear_cache_all/');
      } catch (e) { /* noop */ }
      fetch(`${this.devTestEndpoint}/services/import_backup?profile=${this.customer}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-type': 'application/json'
        }
      })
      .then(() => {
        alert(this.tr('Finished'));
        this.importing = false;
      })
      .catch((error) => {
        alert(error);
        this.importing = false;
      });
    },
    tr (key) {
      if (window.tr && typeof window.tr === 'function') return window.tr(key)
      if (this.$t && typeof this.$t === 'function') return this.$t(key)
      return key
    }
  }
}
</script>

<style scoped>
.form-row .btn {
  height: calc(1.5em + 0.75rem + 2px);
}
</style>
